import { useLang } from "@/lib/i18n";

const FlagNL = ({ active }) => (
  <svg viewBox="0 0 21 15" className={`h-3.5 w-5 rounded-[2px] shadow-sm ${active ? "ring-1 ring-gold" : "ring-0"}`}>
    <rect width="21" height="5" fill="#AE1C28" />
    <rect y="5" width="21" height="5" fill="#FFFFFF" />
    <rect y="10" width="21" height="5" fill="#21468B" />
  </svg>
);

const FlagFR = ({ active }) => (
  <svg viewBox="0 0 21 15" className={`h-3.5 w-5 rounded-[2px] shadow-sm ${active ? "ring-1 ring-gold" : "ring-0"}`}>
    <rect width="7" height="15" fill="#002395" />
    <rect x="7" width="7" height="15" fill="#FFFFFF" />
    <rect x="14" width="7" height="15" fill="#ED2939" />
  </svg>
);

export const LangSwitch = ({ className = "", scope = "" }) => {
  const { lang, setLang } = useLang();
  const pid = (n) => (scope ? `${scope}-lang-switch-${n}` : `lang-switch-${n}`);
  return (
    <div data-testid={pid("group")} className={`flex items-center gap-1.5 ${className}`}>
      <button
        data-testid={pid("nl")}
        onClick={() => setLang("nl")}
        aria-label="Nederlands"
        title="Nederlands"
        className={`flex items-center justify-center h-7 w-8 rounded-full border transition-all duration-300 ${
          lang === "nl" ? "border-gold/70 bg-gold/10" : "border-cream/15 hover:border-gold/40"
        }`}
      >
        <FlagNL active={lang === "nl"} />
      </button>
      <button
        data-testid={pid("fr")}
        onClick={() => setLang("fr")}
        aria-label="Français"
        title="Français"
        className={`flex items-center justify-center h-7 w-8 rounded-full border transition-all duration-300 ${
          lang === "fr" ? "border-gold/70 bg-gold/10" : "border-cream/15 hover:border-gold/40"
        }`}
      >
        <FlagFR active={lang === "fr"} />
      </button>
    </div>
  );
};

export default LangSwitch;
